import React from 'react'
import { Column } from 'primereact/column'
import { Tag } from 'primereact/tag'
import { useIntl } from 'react-intl'
import auxFunction from '../../../utils/helpers/auxFun'
import { DataTableFun } from '../../../utils/helpers/dataTableFun'
import DataTableComp from '../../common/data-table/DataTableComp'
import { bodyCurrencyInput } from '../../common/data-table/column-types/ColumnTypes'
import './priceHistoryDataTable.scss'
import { formatCurrency, formatNumber } from '../../../utils/helpers/common'

const PriceHistoryDataTable = ({
  isSeeCenter,
  prices,
  sortOptions,
  pagerOptions,
}) => {
  const { formatMessage: msg } = useIntl()

  const notificationTemplate = (rowData) => {
    const { val, severity } = auxFunction.pricesReportedBy(rowData)
    return <Tag value={val} severity={severity} />
  }

  const comparareChnagePrice = (price, differencePrice) => {
    //const cent = Math.floor(differencePrice * 100) % 100;
    if (differencePrice > 0) {
      return (
        <div className="cell-change-price">
          {bodyCurrencyInput(price)}
          <i className="pi pi-arrow-up" /> ({formatNumber(differencePrice)})
        </div>
      )
    }
    if (differencePrice < 0) {
      return (
        <div className="cell-change-price">
          {bodyCurrencyInput(price)}
          <i className="pi pi-arrow-down" /> ({formatNumber(differencePrice)})
        </div>
      )
    }
    return bodyCurrencyInput(price)
  }

  return (
    <DataTableComp
      pagerOptions={pagerOptions}
      tableOptions={{
        className: 'table-with-menu ',
        value: prices,
        size: 'small',
        ...sortOptions,
      }}
      columns={[
        <Column
          field="createdAt"
          header={msg({ id: 'date.send' })}
          body={(rowData) => auxFunction.parseDateAndHour(rowData.createdAt)}
          sortable
        />,
        <Column
          field="changeDate"
          header={msg({ id: 'date.change' })}
          body={(rowData) => auxFunction.parseDateAndHour(rowData.changeDate)}
          sortable
        />,
        isSeeCenter && (
          <Column field="centerName" header={msg({ id: 'center' })} sortable />
        ),
        <Column
          field="prices.GOA"
          header="GOA"
          body={(rowData) =>
            comparareChnagePrice(
              rowData?.prices?.GOA,
              rowData?.differencePrices?.GOA,
            )
          }
        />,
        <Column
          field="prices.GOAPLUS"
          header="GOAPLUS"
          body={(rowData) =>
            comparareChnagePrice(
              rowData?.prices?.GOAPLUS,
              rowData?.differencePrices?.GOAPLUS,
            )
          }
        />,
        <Column
          field="prices.G95"
          header="G95"
          body={(rowData) =>
            comparareChnagePrice(
              rowData?.prices?.G95,
              rowData?.differencePrices?.G95,
            )
          }
        />,
        <Column
          field="prices.AdBlue"
          header="AdBlue"
          body={(rowData) =>
            comparareChnagePrice(
              rowData?.prices?.AdBlue,
              rowData?.differencePrices?.AdBlue,
            )
          }
        />,
        <Column
          field="status.alvic"
          header={msg({ id: 'status.alvic' })}
          body={(rowData) =>
            DataTableFun.statusNotificationPricesTemplate(
              rowData?.status?.alvic,
            )
          }
        />,
        <Column
          field="status.minetur"
          header={msg({ id: 'status.minetur' })}
          body={(rowData) =>
            DataTableFun.statusNotificationPricesTemplate(
              rowData?.status?.minetur,
            )
          }
        />,
        <Column
          field="notification"
          header={msg({ id: 'notification.by' })}
          body={notificationTemplate}
        />,
      ]}
    />
  )
}

export default PriceHistoryDataTable
